import useSWR from 'swr';

import ENDPOINTS from '../ENDPOINTS';

import fetcherWithAuth from './utils/fetcherWithAuth';

const useStore = (id, token) =>
  useSWR(
    id && token ? [`${ENDPOINTS.stores}/${id}`, token] : null,
    fetcherWithAuth
  );

export default useStore;
